

































import { ITxData, ICoin } from '@/typings'
import { AxiosResponse } from 'axios'
import Getters from '@/mixins/Getters'
import explorer from '@/services/explorer'
import Submit from '@/components/send/Submit.vue'
import Payload from '@/components/send/Payload.vue'
import SendError from '@/components/send/SendError.vue'
import SendSuccess from '@/components/send/SendSuccess.vue'
import Controls from '@/components/send/Controls.vue'
import InputManual from '@/components/send/InputManual.vue'
import InputImport from '@/components/send/InputImport.vue'
import { Component, Mixins, Watch } from 'vue-property-decorator'

const FEE_UNIT = 0.001

@Component({
  name: 'Send',
  components: {
    Submit,
    SendError,
    SendSuccess,
    Payload,
    Controls,
    InputManual,
    InputImport
  }
})
export default class Send extends Mixins(Getters) {
  // Change coin for each item in multisend list on master coin change
  @Watch('dataStore.masterCoin')
  protected onMasterCoinChange(coin: number) {
    this.dataStore.txData.map((txData: ITxData, index: number) => {
      if (this.dataStore.txData[index]) {
        this.dataStore.commitTxDataCoinChange({ coin, index })
      }
    })
  }

  // Recalculate fee on list / payload change
  @Watch('dataStore.payload')
  @Watch('dataStore.txData', { deep: true })
  protected onTxDataChange() {
    if (this.dataStore.validTxData.length === 0) { return }

    const multisendFee = 10 + (this.dataStore.validTxData.length - 1) * 5
    const payloadBytesLength = (new TextEncoder().encode(this.dataStore.payload)).length
    const payloadFee = payloadBytesLength ? payloadBytesLength * 2 : 0
    const fee = (multisendFee + payloadFee) * FEE_UNIT

    this.dataStore.commitFee(fee)
  }

  // Load coins from API before mount
  protected beforeMount() {
    explorer.get('/coins')
      .then((response: AxiosResponse) => {
        const coinsSymbols = response.data.data
          .map((coin: ICoin) => {
            return {
              id: coin.id,
              symbol: coin.symbol
            }
          })
          .sort()

        this.dataStore.commitCoins(coinsSymbols)
      })
      .catch((e: Error) => {
        this.dataStore.commitError(e)
      })
  }

  // Reset form
  protected reset() {
    this.dataStore.dispatchReset()
  }
}
